// imports
import { IAPIQuests } from './config';

// interfaces / types / consts
let PRV_URL_IDX = -1;
const API_KEY = process.env.REACT_APP_REST_API_KEY || '';
const BASE_URL = process.env.REACT_APP_REST_API_BASE_URL || '';
type IAPI_RESPONSE = { result: string; status?: string; message?: string };

// exports
export const get = (): Promise<IAPIQuests> => {
  const URL = `${BASE_URL}/game/quests/available`;
  return fetch(URL, {
    headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
  }).then((response) => {
    if (response.status === 200) { return response.json(); }
    return response.json().then((errMsg) => Promise.reject(errMsg));
  });
};
export const action = (reqBody: object, walletId: number): Promise<string> => {
  const URL = `${BASE_URL}/game/quests/actions`;
  if (PRV_URL_IDX === -1) {
    PRV_URL_IDX = walletId % 100;
  } else {
    PRV_URL_IDX = (PRV_URL_IDX + 1) % 100;
  }
  return fetch(URL, {
    method: 'POST',
    body: JSON.stringify({ ...reqBody, reqId: PRV_URL_IDX }),
    headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
  }).then((response) => response.json())
    .then((response: IAPI_RESPONSE) => {
      if (response.result) { return JSON.parse(response.result).txHash; }
      return Promise.reject(new Error(response.message || ''));
    });
};

export default { get, action };
